<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    @delete-cancel-action="cancelAction"
    @delete-open-action="loadServerEntry(entry.id)"
    deleteTitle="Duplicar Pedido de Venda"
    :formErrors="formErrors"
    ref="baseDelete"
    deleteConfirmButtonLabel="Duplicar pedidos"
    deleteIcon="mdi-multicast"
    deleteButtonLabel="Duplicar pedidos"
    deleteColor="grey"
    :alwaysEnabled="true"
    :pageLoading="pageLoading"
    :loading="loading"
  >

    <p>Preencha a data dos novos pedidos, a data da primeira parcela, o período de dias entre cada pedido e quantos devem serem gerados.</p>

    <v-row>

      <v-col cols="12" sm="6" v-if="!pageLoading">
        <DateField
          :inputData.sync="editableEntry.initialDate"
          label="Data do pedido"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>
      
      <v-col cols="12" sm="6" v-if="!pageLoading">
        <DateField
          :inputData.sync="editableEntry.firstInstallmentDate"
          label="Data da 1ª parcela"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="12" v-if="!pageLoading">
        <v-text-field
          v-model="editableEntry.periodInterval"
          label="Período (Número de dias entre os pedidos)"
          type="number"
          :suffix="'dia(s)'"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="6" v-if="!pageLoading">
         <v-text-field
            v-model="editableEntry.duplicateNumber"
            label="Número de pedidos"
            persistent-hint
            type="number"
            :disabled="readOnly"
            autocomplete="off"
          />
      </v-col>

    </v-row>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";
// import MaskedTextField from "@shared_components/masked_text_field.vue";
import DateField from "@shared_components/date_field.vue";

export default {
  data () {
    return { 
      error: null,
      loading: false,
      pageLoading: true,
      editableEntry: null,
      formErrors: [],
      // periodOptions: [{name: '15 em 15 dias', id: 15}, {name: '30 em 30 dias', id: 30}],
    }
  },
  components: {
    BaseDelete: BaseDelete,
    DateField: DateField,
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    loadServerEntry: function(id) {
      this.error = null;
      this.$apollo
        .query({
          query: LOAD_SALE_ORDER_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.saleOrder;
          // this.extraData = response.data;
          // console.log("saleOrder edit", this.editableEntry);
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));

    },
    destroyServerEntry: function(saleOrder) {
      // console.log("saleOrder", saleOrder, saleOrder.validations, this.deepFilterEntryWithAllowedFieldsForMutation(saleOrder, saleOrder.validations));
      saleOrder.duplicateNumber = parseInt(saleOrder.duplicateNumber);
      saleOrder.periodInterval = parseInt(saleOrder.periodInterval);
      // saleOrder.periodInterval = this.periodInterval;

      this.loading = true;
        this.$apollo
          .mutate({
            mutation: DUPLICATE_SALE_ORDER_MUTATION,
            variables: {
              input: this.deepFilterEntryWithAllowedFieldsForMutation(saleOrder, saleOrder.validations)
            }
          })
          .then(response => {
            var errors = response.data.duplicateSaleOrder.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.editableEntry);
    },
    cancelAction: function() {
      this.$emit('entry-canceled');
    }
  }
}
const DUPLICATE_SALE_ORDER_MUTATION = gql `
  mutation($input: SaleOrderUpdateInputObject!) {
    duplicateSaleOrder(input: $input) {
      cashFlow {
        id
      }
      errors
    }
  }
`;

const LOAD_SALE_ORDER_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      saleOrder(id: $id) {
        id
        code
        billDate
        date
        estimatedDeliveryDate
        fiscalDocumentType
        orderValidity
        customerId
        customerId
        totalPrice
        observation
        validations
        duplicateNumber
        periodInterval
        initialDate
        firstInstallmentDate
        carrierId
        carrier {
          id
        }
        carriageModalityId
        carriageModality {
          id
        }
        carrierPatrimonyId
        carrierPatrimony {
          id
        }
        carrierLicensePlate
        carrierLicensePlateStateId
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        dummyExitMovementItemsAttributes {
          id
          price
          quantity
          itemId
          storageId
          isNewItemInStorage
          unitPrice
          item {
            id
            name
            description
            unit {
              name
            }
          }
          storage {
            id
            name
          }
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsInterval {
            id
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
      }
      allCustomers {
        id
        name
      }
      allCarriers {
        id
        name
      }
    }
    globalContext {
			allPaymentConditions {
        id
        description
        numberOfInstallments
      }
      allCarriageModalities {
        id
        text
      }
      allStates {
        id
        shortName
      }
    }
  }
`;

</script>

<style scoped></style>
